var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"menuButton"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();return _vm.setMenu.apply(null, arguments)}}},[_vm._v(" MENU ")])}
var staticRenderFns = []

export { render, staticRenderFns }